import axios from 'axios'

export default class Usuario {
  constructor (tokenBearer, url, id) {
    this.url = `${url}/api/unimed/enderecos/${id}`
    this.tokenBearer = tokenBearer
  }

  getEnderecos (args = '') {
    return new Promise(async (resolve, reject) => {
      let optionsEndereco = {
        method: 'get',
        url: `${this.url}/${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseEndereco = await axios(optionsEndereco)
        resolve(responseEndereco)
      } catch (err) {
        reject(err)
      }
    })
  }

  putEndereco (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  delEndereco (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'delete',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
